import { Component, Input, ViewChild, ElementRef } from '@angular/core';
import { DataExportType, ExcelExportService } from '../../services/export/excel/excel-export.service';
import { EThemeName, ThemeService } from '@wind-log_library/fe-component-library';
import { Observable } from 'rxjs';
import { LogbookExportExcelHelper } from 'app/tclasses/helpers/block-table-excel-export';


@Component({
    selector: 'app-export-data',
    templateUrl: './export-data.component.html',
    styleUrls: ['./export-data.component.scss'],
    standalone: false
})
export class ExportDataComponent {
    @Input() tableToExport: any;
    @Input() fileName: string;
    @Input() module: string;
    @Input() buttonDisabled: boolean;
    @Input() columnsToDisplay: string[];
    @Input() JSONdata: string;
    @Input() customLabel: string;

    public toggle = false;
    public theme$: Observable<EThemeName>;

    options = [ '.xlsx', '.csv' ];

    constructor(private excelService: ExcelExportService,
                private logbookExportExcelHelper: LogbookExportExcelHelper,
                private themeService: ThemeService) {
        this.theme$ = this.themeService.getTheme();
    }

    public toggleDropdown() {
        this.toggle = !this.toggle;
    }

    public closeDropdown() {
        this.toggle = false;
    }

    public onDropdownSelected(option: any) {
      if (this.module === 'logbook_1' || this.module === 'logbook_2' || this.module === 'logbook_losses' || this.module === 'planning_events') {
          if (this.module === 'planning_events') {
            this.excelService.exportJSONasTable(this.tableToExport, this.fileName, option.index === 0 ? DataExportType.xlsx : DataExportType.csv);
            return;
          }
          if (this.module === 'logbook_losses') {
            this.excelService.exportTableAsFile(
                this.tableToExport,
                this.fileName,
                option.index === 0 ? DataExportType.xlsx : DataExportType.csv)
            } else {
              const tableData = this.logbookExportExcelHelper.getLogbookTableToExport(this.tableToExport, this.columnsToDisplay);
              const columnWidth = this.logbookExportExcelHelper.getExcelFileColumnWidth(tableData);
              this.excelService.exportAsExcelFile(tableData, this.fileName, option.index, columnWidth)
            }
        } else {
            if (this.module === 'kpi_fu_grid_curtailments') {
              this.excelService.exportGridCurtailmentsTableAsFile(
                  this.tableToExport,
                  this.fileName,
                  option.index === 0 ? DataExportType.xlsx : DataExportType.csv,
              );
            } else {
              if (['logbook_park_summary', 'series_data_table'].includes(this.module)) {
                this.excelService.exportLogbookParkSummaryTableAsFile(
                    this.JSONdata,
                    this.fileName,
                    option.index === 0 ? DataExportType.xlsx : DataExportType.csv,
                    this.module === 'series_data_table'
                );
              } else {
                this.excelService.exportTableAsFile(
                    this.tableToExport,
                    this.fileName,
                    option.index === 0 ? DataExportType.xlsx : DataExportType.csv
                );
              }
            }
        }
    }
}
